import(/* webpackMode: "eager" */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/app/ar/components/Footer.tsx");
